import { render, staticRenderFns } from "./sorteo.vue?vue&type=template&id=45be6079"
import script from "./sorteo.vue?vue&type=script&lang=ts"
export * from "./sorteo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports